import { StyleSheet } from 'react-native';
import { UIHelper as uh } from '../../core';
export const authStyles = StyleSheet.create({
  // Auth Root Container of the Application
  authScreenContainer: {
    paddingHorizontal: uh.w2DP(24),
    paddingTop: uh.h2DP(16),
    paddingBottom: uh.h2DP(50)
  }
});
